import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { createABAMiddleware } from '@corefront/redux-aba';
import { SERVICE_NAME } from '../constants';
import service from '../services';
import rootReducer from './reducers';
import rootSaga from './sagas';
import actions from './actions';
import type { PartialRootState } from '../types/redux';

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof configureStore>;

const sagaMiddleware = createSagaMiddleware();
const abaMiddleware = createABAMiddleware(service);

const middlewares = [sagaMiddleware, abaMiddleware];

const devtoolsExtensionConfig = {
  name: `${SERVICE_NAME}/${window.location.hostname}`,
  actionCreators: {
    useDebug: actions.useDebugMode,
    useLocalGameLaunchMode: actions.setLocalGameLaunchMode,
  },
};

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: (options: {
      name: string;
    }) => typeof compose;
  }
}

/**
 * Enable redux-devtools extension for Chrome
 */
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__(devtoolsExtensionConfig)
  : compose;

export default function configureStore(
  initialState: PartialRootState<RootState> = {}
) {
  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(...middlewares))
  );

  sagaMiddleware.run(rootSaga);

  return store;
}
